import { showPersonalApiKeysRevokeModal } from "components/ApiKeys/PersonalApiKeys/RevokeModal";
import { Trash } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { UserPersonalApiKeyRow } from "../../types";

const UserPersonalApiKeysTableActionsCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<UserPersonalApiKeyRow>) => {
  const onRevokeClick = () => {
    showPersonalApiKeysRevokeModal({
      id: apiKey.id,
      name: apiKey.name,
      owner: apiKey.owner,
    });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <ButtonIcon
        onPress={onRevokeClick}
        icon={Trash}
        variant="ghostDanger"
        tooltipPlacement="left"
      >
        Revoke API key
      </ButtonIcon>
    </TableSimpleCell>
  );
};

export default UserPersonalApiKeysTableActionsCell;
